import dayjs from "dayjs";
import { t } from "i18next";

export const DATES_PRESELECTION = [
    {
        title: 'daterangepicker:today',
        startDate: dayjs().toISOString(),
        endDate: dayjs().toISOString(),
        value:'TODAY'
    },
    {
        title: 'daterangepicker:last7days',
        startDate: dayjs().toISOString(),
        endDate: dayjs().subtract(7, 'days').toISOString(),
        value:'7DAYS'

    },
    {
        title: 'daterangepicker:last30days',
        startDate: dayjs().toISOString(),
        endDate: dayjs().subtract(30, 'days').toISOString(),
        value:'30DAYS'

    },
    {
        title: 'daterangepicker:thismonth',
        startDate: dayjs().startOf('month').toISOString(),
        endDate: dayjs().endOf('month').toISOString(),
        value:'CURR_MONTH'

    },
    {
        title: 'daterangepicker:last3Months',
        startDate: dayjs().startOf('month').subtract(3, 'month').toISOString(),
        endDate: dayjs().startOf('month').subtract(1, 'day').toISOString(),
        value:'3_MONTHS'

    },    
    {
        title:'daterangepicker:last6Months',
        startDate: dayjs().startOf('month').subtract(6, 'month').toISOString(),
        endDate: dayjs().startOf('month').subtract(1, 'day').toISOString(),
        value:'6_MONTHS'

    },
    {
        title: 'daterangepicker:lastyear',
        startDate: dayjs().subtract(1, 'year').startOf('year').toISOString(),
        endDate: dayjs().subtract(1, 'year').endOf('year').toISOString(),
        value:'YEAR'

    },
    {
        title: 'daterangepicker:last2years',
        startDate: dayjs().subtract(2, 'year').startOf('year').toISOString(),
        endDate: dayjs().subtract(2, 'year').endOf('year').toISOString(),
        value:'2_YEARS'

    },
 
    
]